import api from '@/services/api'

export const getDashboards = async (params = {}) => {
    try {
        const resp = await api.get('/reports/dashboards', {
            params,
        })
        return resp.data.data
    } catch (e) {
        console.error(e)
        return []
    }
}

export const getDashboard = async (id, params = {}) => {
    try {
        const resp = await api.get(`/reports/dashboards/${id}`, { params })
        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const createDashboard = async (data) => {
    try {
        const resp = await api.post('/reports/dashboards', data)
        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const updateDashboard = async (id, data) => {
    try {
        return await api.put(`/reports/dashboards/${id}`, data)
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const deleteDashboard = async (id) => {
    try {
        return await api.delete(`/reports/dashboards/${id}`)
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const duplicateDashboard = async (id) => {
    try {
        const resp = await api.put(`/reports/dashboards/${id}/duplicate`)
        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const getEvaluationsCountFromApi = async (filters, type) => {
    try {
        const response = await api.post('/reports/evaluations', {
            ...filters,
            type,
        })

        return response.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const getQuestionnairesResults = async (filters, page) => {
    try {
        const response = await api.post('/reports/questionnaires-results', {
            ...filters,
            page,
        })

        return response.data.data
    } catch (e) {
        console.error(e)
    }
}

export const getValuesResults = async (filters) => {
    try {
        const response = await api.post('/reports/values-results', filters)

        return response.data.data
    } catch (e) {
        console.error(e)
        return []
    }
}

export const getGeneralAveragesResults = async (filters) => {
    try {
        const response = await api.post('/reports/averages-results', filters)

        return response.data.data
    } catch (e) {
        console.error(e)
        return []
    }
}
